import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'
import * as Yup from 'yup'
import {
  changeAssignee,
  changeStatus,
  createComment,
  deleteComment,
  getAssignees,
  uploadDocAndPrice,
} from '../TicketingAPI'
import styles from '../TicketingStyles/TicketingStyles.module.scss'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import {CircularProgress} from '@mui/material'
import {TicketingDetailsDataType, assigneeDataType} from '../TicketingDataType'
import {ticketDetailsValidationSchema} from '../TicketingValidationSchema'
import {Document, Page, pdfjs} from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import { useDropzone } from 'react-dropzone'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const modalsRoot = document.getElementById('root-modals') || document.body
interface commentColorsDataType {
  [key: string]: string[]
}
const TicketingDetails = ({
  showTicketingDetail,
  handleClose,
  ticket,
  convertTicketNumberFormat,
  setBadgeColor,
  formatDate,
  getListOfTickets,
  allStatus,
}: TicketingDetailsDataType) => {
  var user = localStorage.getItem('user_type')
  const {currentUser} = useAuth()
  const [selectedStatus, setSelectedStatus] = useState<string>()
  const [createCommentLoading, setCreateCommentLoading] = useState<boolean>(false)
  const [assignee, setAssignee] = useState<assigneeDataType[]>()
  // const [changeAssigeeLoader, setChangeAssigeeLoader] = useState<boolean>(false)
  // const [deleteCommentLoader, setDeleteCommentLoader] = useState<boolean>(false)
  const [showMore, setShowMore] = useState<boolean>(false)
  // const [editAssignee, setEditAssignee] = useState<boolean>(false)
  const [numPages, setNumPages] = useState<number>()
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [commentColors, setCommentColors] = useState<commentColorsDataType>({
    [currentUser?.account_uuid ? currentUser?.account_uuid : '']: [
      'hsl(325, 43%, 47%,0.2)',
      'hsl(325, 43%, 47%, 1)',
    ],
  })
  const [CountComment, setCountComment] = useState<number>(1)
  // const [price, setPrice] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  function onDocumentLoadSuccess({numPages}: {numPages: number}): void {
    setNumPages(numPages)
  }

  const handlePrevious = () => {
    setPageNumber((preval) => preval - 1)
  }
  const handleNext = () => {
    setPageNumber((preval) => preval + 1)
  }

  function generateDiffColors() {
    ticket.comments.map((comment, index) => {
      if (!commentColors.hasOwnProperty(comment.comment_account_uuid)) {
        const goldenRatio = 0.618033988749895 // Used for even distribution of hues
        let hue = Math.random() // Starting hue value
        const saturation = 0.5 // Fixed saturation value
        const lightness = 0.6 // Fixed lightness value
        hue = (hue + goldenRatio) % 1 // Incrementing hue value
        setCommentColors((commentColors) => ({
          ...commentColors,
          [comment.comment_account_uuid]: [
            `hsla(${Math.floor(hue * 360)}, ${Math.floor(saturation * 100)}%, ${Math.floor(
              lightness * 100
            )}%, 0.2)`,
            `hsl(${Math.floor(hue * 360)}, ${Math.floor(saturation * 100)}%, ${Math.floor(
              lightness * 100
            )}%, 1)`,
          ],
        }))
      }
    })
  }
  // function to get list of assignees
  const getListAssignees = async () => {
    if (ticket.propertyDtls[0].ticket_end_job_type_uuid) {
      try {
        const {data: response} = await getAssignees(
          ticket?.propertyDtls && ticket.propertyDtls.length > 0
            ? ticket.propertyDtls[0].ticket_end_job_type_uuid
            : ''
        )
        if (response.code === '200') {
          setAssignee(response.data)
        } else if (response.code === '204') {
          setAssignee(response.data)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
    }
  }
  useEffect(() => {
    setSelectedStatus(ticket.ticket_status_uuid)
    generateDiffColors()
    getListAssignees()
  }, [])

  // Initial values for the formik
  const ticketDetailsInitialValues = {
    ticket_status_uuid: ticket.ticket_status_uuid,
    ticket_comment_text: '',
    assignee_account_uuid:
      ticket.assignee.length > 0 ? ticket.assignee[0].assignee_account_uuid : '',
      ticket_price: ticket.ticket_price ? ticket.ticket_price : null,
  }

  // formik for ticket details
  const formik = useFormik({
    initialValues: ticketDetailsInitialValues,
    enableReinitialize: true,
    validationSchema: ticketDetailsValidationSchema,
    onSubmit: () => console.log(''),
  })

  // function to create comment in the ticket details
  const createCommentForTicket = async (ticket_uuid: string) => {
    if (formik.values.ticket_comment_text && !formik.errors.ticket_comment_text) {
      setCreateCommentLoading(true)
      try {
        const {data: response} = await createComment(formik.values.ticket_comment_text, ticket_uuid)
        if (response.code === '200') {
          getListOfTickets(false)
          formik.setFieldValue('ticket_comment_text', '', true)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
          allowOutsideClick: true,
        })
      } finally {
        setCreateCommentLoading(false)
      }
    }
  }

   // dropzone code start
   const {acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
    maxFiles: 3,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
    },
  })

  const acceptedFileItems = acceptedFiles.map((file) => {
    return (
      // @ts-ignore
      <li key={file.path}>
        {
          // @ts-ignore
          file.path
        }{' '}
        - {file.size} bytes
      </li>
    )
  })

  const fileRejectionItems = fileRejections.map(({file, errors}) => (
    // @ts-ignore
    <li key={file.path}>
      {
        // @ts-ignore
        file.path
      }{' '}
      - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ))

  // function to status change for the ticket
  const handleStatusChange = async (val: string) => {
    if (val) {
      setSelectedStatus(val)
      formik.setFieldValue('ticket_status_uuid', val, true)
      try {
        const {data: response} = await changeStatus(val, ticket.ticket_uuid)
        if (response.code === '200') {
          getListOfTickets(false)
        } else {
          formik.setFieldValue('ticket_status_uuid', ticket.ticket_status_uuid, true)
          setSelectedStatus(ticket.ticket_status_uuid)
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
          allowOutsideClick: true,
        })
      }
      // finally {
      //   setCreateCommentLoading(false)
      // }
    }
  }

  // function to delete the comment
  const deleteTicketComment = async (ticket_comment_uuid: string) => {
    // setDeleteCommentLoader(true)
    try {
      const {data: response} = await deleteComment(ticket_comment_uuid)
      if (response.code === '200') {
        getListOfTickets(false)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
        allowOutsideClick: true,
      })
    }
    // finally {
    //   setDeleteCommentLoader(false)
    // }
  }

  // function to change the assignee
  const handleAssigneeChange = async (val: string) => {
    if (val) {
      // setChangeAssigeeLoader(true)
      try {
        const {data: response} = await changeAssignee(val, ticket.ticket_uuid)
        if (response.code === '200') {
          getListOfTickets(false)
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
          allowOutsideClick: true,
        })
      }
      // finally {
      //   setChangeAssigeeLoader(false)
      // }
    }
  }
  // function to upload doc and price
  const handleUploadDocAndPrice = async () => {
    setLoading(true);
    const price = Number(formik.values.ticket_price);
    const promises = acceptedFiles.map((file) => {
      return new Promise<{file: string}>((resolve) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          const base64String = (event.target!.result as string).split(',')[1]
          resolve({file: base64String})
        }
        reader.readAsDataURL(file)
      })
    })
    const convertedFiles = await Promise.all(promises)

    try {
      const {data: response} = await uploadDocAndPrice(convertedFiles, price, ticket.ticket_uuid)
      if (response.code === '200') {
        getListOfTickets(false);
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
        setLoading(false);
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        });
        setLoading(false);
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
        allowOutsideClick: true,
      });
      setLoading(false);
    }
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-700px'
      show={showTicketingDetail ? true : false}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header py-4'>
        {/* begin::Heading */}
        <div className='d-flex flex-column'>
          {/* Begin: Ticket number */}
          <p className='m-0 fw-bolder text-muted'>
            {convertTicketNumberFormat(ticket.ticket_number)}
          </p>
          {/* End: Ticket number */}
          {/* Begin: Ticket title */}
          <h2>{ticket.ticket_title.charAt(0).toUpperCase() + ticket.ticket_title.slice(1)}</h2>
          {/* End: Ticket title */}
        </div>
        {/* end::Heading */}
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body px-10 py-4'>
        {/*Begin::Form Group Ticket description */}
        <div>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>Property Name</span>
          <p className='text-dark fw-semibold d-block fs-4'>
            {ticket?.propertyDtls && ticket.propertyDtls.length > 0
              ? ticket.propertyDtls[0].property_title.charAt(0).toUpperCase() +
                ticket.propertyDtls[0].property_title.slice(1)
              : '-'}
          </p>
        </div>
        <div>
          <span className='text-muted fw-semibold text-muted d-block fs-6'>Description</span>
          <p className='text-dark fw-semibold d-block fs-4'>
            {ticket.ticket_description.length <= 200 ? (
              <>
                {ticket.ticket_description.charAt(0).toUpperCase() +
                  ticket.ticket_description.slice(1)}
              </>
            ) : (
              <>
                {showMore ? (
                  <>
                    <span>
                      {ticket.ticket_description.charAt(0).toUpperCase() +
                        ticket.ticket_description.slice(1)}
                    </span>
                    <span
                      className='text-primary underline cursor-pointer'
                      onClick={() => setShowMore(false)}
                    >
                      {` `}
                      <u>show less</u>
                    </span>
                  </>
                ) : (
                  <>
                    <span>
                      {`${(
                        ticket.ticket_description.charAt(0).toUpperCase() +
                        ticket.ticket_description.slice(1)
                      ).slice(0, 200)}...`}
                    </span>
                    <span className='text-primary cursor-pointer' onClick={() => setShowMore(true)}>
                      {` `}
                      <u>show more</u>
                    </span>
                  </>
                )}
              </>
            )}
          </p>
        </div>
        {/*Begin::Form Group Ticket description */}
        {/*Begin::Form */}
        <form onSubmit={formik.handleSubmit} className='form'>
          {/* Begin: Form field status */}
          <div className={`${styles.max_w_49} mb-4`}>
            <label className='d-flex align-items-center fs-5 fw-semibold pb-1'>
              <span className='text-muted fw-semibold text-muted d-block fs-6'>Status</span>
            </label>
            {user === 'Non-Tenant' ? (
              <select
                className={`form-select py-2 px-4 ${
                  selectedStatus && setBadgeColor(selectedStatus)
                }`}
                {...formik.getFieldProps('ticket_status_uuid')}
                name='ticket_status_uuid'
                placeholder='Select status'
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option className='bg-color-gray text-dark' value=''>
                  Select status
                </option>
                {allStatus?.map((item) => {
                  return (
                    <option
                      key={item.ticket_status_uuid}
                      value={item.ticket_status_uuid}
                      className='bg-color-white text-dark'
                    >
                      {item.ticket_status_name}
                    </option>
                  )
                })}
              </select>
            ) : (
              <p className={`badge fs-4 px-3 py-2 ${setBadgeColor(ticket.ticket_status_uuid)}`}>
                {ticket.ticket_status_name}
              </p>
            )}
          </div>
          {/* End: Form field status */}

          {/*End::Form Group Created by and assignee */}
          <section className='card border border-2 rounded border-muted border-dashed w-100 symbol  p-4'>
            <div className='container'>
              {/* Begin: field Created by */}
              <div className='row my-2'>
                <div className='col fw-bold text-muted fs-6'>Created by</div>
                <div className='col-9 fw-bold fs-6 pb-1'>
                  {ticket.ticket_creater_name.charAt(0).toUpperCase() +
                    ticket.ticket_creater_name.slice(1)}
                </div>
              </div>
              {/* End: field Created by */}
              {/* Begin: form field Assignee */}
              <div className='row my-2'>
                <div className='col fw-bold text-muted fs-6'>Assignee</div>
                <div className='col-9 fw-bold fs-6 pb-1'>
                  {user === 'Non-Tenant' ? (
                    <select
                      className={`form-select form-select-solid ${styles.max_w_48}`}
                      {...formik.getFieldProps('assignee_account_uuid')}
                      name='assignee_account_uuid'
                      placeholder='Select assignee'
                      onChange={(e) => handleAssigneeChange(e.target.value)}
                    >
                      <option className='bg-color-gray' value=''>
                        Select assignee
                      </option>
                      {assignee?.map((item: assigneeDataType) => {
                        return (
                          <option key={item.account_uuid} value={item.account_uuid}>
                            {item.accouont_holder_name}
                          </option>
                        )
                      })}
                    </select>
                  ) : (
                    <div className='col-9 fw-bold fs-6 pb-1'>
                      {ticket.assignee.length > 0
                        ? ticket.assignee[0].assignee_account_name.charAt(0).toUpperCase() +
                          ticket.assignee[0].assignee_account_name.slice(1)
                        : '-'}
                    </div>
                  )}
                </div>
                {/*End::Form Group assignee */}
              </div>
              {/* End: form field Assignee */}
            </div>
          </section>

          {/*begin::Form Property Share */}
          <section className='card border border-2 rounded border-muted border-dashed w-100 symbol px-4 py-7 mt-5'>
          <div className='fv-row mb-1'>
            <label className='d-flex fs-5 fw-semibold mb-2'>
              <span className=''>Price</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter Price'
              ></i>
            </label>
            <input
              type='number'
              className='form-control form-control-lg form-control-solid w-50'
              placeholder='Enter Price'
              {...formik.getFieldProps('ticket_price')}
              name='ticket_price'
              onChange={(e) => formik.setFieldValue('ticket_price', Number(e.target.value))} // Update Formik's state
            />

            {/* <div className='h-20px'>
              {formik.touched.rentalShare && formik.errors.rentalShare && (
                <div className='fv-help-block color-red'>{formik.errors.rentalShare}</div>
              )}
            </div> */}
          </div>
          {/*end::Form Property Share */}
          {/* Begin Document Upload */}
          <div className='fv-row pb-5'>
              <label className='d-flex fs-5 fw-semibold pb-1 pt-5'>
                <span className=''>Document upload</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Upload documents related to the ticket'
                ></i>
              </label>
              <div className='d-flex justify-content-between'>
                {/*begin::Dropzone field */}
                <div
                  className={`border border-2 rounded border-dashed row p-1 bg-white mx-1 text-center ${
                    acceptedFileItems.length > 0 || fileRejectionItems.length > 0
                      ? styles.max_w_49
                      : 'w-100'
                  }`}
                >
                  <section className='border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary'>
                    <div
                      {...getRootProps({
                        className:
                          'py-2 d-flex flex-column justify-content-center align-items-center',
                      })}
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p className='mb-1'>Drop the files here...</p>
                      ) : (
                        <p className='mb-1'>Drag and drop files here, or click to select files</p>
                      )}
                      <i className='bi bi-file-earmark-arrow-up-fill fs-3x btn btn-active-color-primary py-0 mb-1'></i>
                      <span className='text-primary fs-7'>
                        Type: *.jpeg, *.jpg, *.png, *.pdf only
                      </span>
                      <span className='text-primary fs-7'>Max document:3</span>
                    </div>
                  </section>
                </div>

                <aside
                  className={` ${
                    acceptedFileItems.length > 0 || fileRejectionItems.length > 0
                      ? `${styles.max_w_49} px-2 me-2`
                      : 'w-0'
                  }`}
                >
                  {acceptedFileItems.length > 0 && (
                    <div className='pt-2'>
                      <h4>Document is ready to upload</h4>
                      <ul>{acceptedFileItems}</ul>
                    </div>
                  )}
                  {fileRejectionItems.length > 0 && (
                    <div className='pt-2'>
                      <span className='fv-help-block color-red'>
                        Upload only three files or select files with allowed formats only
                      </span>
                      {/* <ul>{fileRejectionItems}</ul> */}
                    </div>
                  )}
                </aside>
                {/*end::Dropzone field */}
              </div>
            </div>

          {/* End Document Upload */}

          <button
              type='submit'
              className='btn btn-lg btn-primary mx-auto mt-2 py-3 w-50'
              onClick={handleUploadDocAndPrice}
              disabled={loading}
              > 
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          </section>

          <p className='text-muted my-1'>{`Created at ${formatDate(
            new Date(ticket.created_date_time)
          )}`}</p>

          {/* Begin: carousel */}
          {ticket.ticket_documents.length > 0 && (
            <div
              id='carouselExampleDark'
              className={`carousel carousel-dark slide pt-2 ${styles.h_50vh}`}
              data-bs-ride='carousel'
            >
              <div className='carousel-indicators mb-5'>
                {ticket.ticket_documents.map((doc, index: number) => {
                  return (
                    <button
                      key={index}
                      type='button'
                      data-bs-target='#carouselExampleDark'
                      data-bs-slide-to={index}
                      className={`${index === 0 && 'active'}`}
                      aria-current={index === 0 && 'true'}
                      aria-label={`Slide ${index + 1}'`}
                    ></button>
                  )
                })}
              </div>
              <div className='carousel-inner'>
                {ticket.ticket_documents.map((doc, index: number) => {
                  return (
                    <div
                      className={`carousel-item ${index === 0 && 'active'}`}
                      data-bs-interval='10000'
                      key={index}
                    >
                      {doc.document_file_type === 'image' ? (
                        <img
                          className={`m-auto w-100 object-fit-contain ${styles.h_50vh}`}
                          src={doc.document_path}
                          alt={doc.created_date_time}
                        />
                      ) : (
                        <iframe
                          title='pdf'
                          className={`m-auto w-100 object-fit-contain ${styles.h_50vh}`}
                          src={doc.document_path}
                        ></iframe>
                      )}
                    </div>
                  )
                })}
              </div>
              <button
                className='carousel-control-prev'
                type='button'
                data-bs-target='#carouselExampleDark'
                data-bs-slide='prev'
              >
                <span className='carousel-control-prev-icon' aria-hidden='true'></span>
                <span className='visually-hidden'>Previous</span>
              </button>
              <button
                className='carousel-control-next'
                type='button'
                data-bs-target='#carouselExampleDark'
                data-bs-slide='next'
              >
                <span className='carousel-control-next-icon' aria-hidden='true'></span>
                <span className='visually-hidden'>Next</span>
              </button>
            </div>
          )}
          {/* End: carousel */}

          {/* begin::Separator */}
          <div className='separator my-6'></div>
          {/* end::Separator */}

          {/* Begin::Reply input */}
          <div className='position-relative mb-1 border p-3 rounded'>
            <textarea
              {...formik.getFieldProps('ticket_comment_text')}
              name='ticket_comment_text'
              className='form-control border-0 p-0 pe-10 resize-none min-h-40px'
              data-kt-autosize='true'
              rows={1}
              placeholder='Reply..'
            ></textarea>
            <div className='position-absolute top-0 end-0 mt-5'>
              {createCommentLoading ? (
                <CircularProgress />
              ) : (
                <button
                  type='submit'
                  className='btn btn-icon btn-sm btn-active-color-primary pe-0 me-2'
                  disabled={createCommentLoading}
                >
                  <i
                    className='bi bi-caret-right-fill fs-2x btn btn-active-color-primary svg-icon-3 mb-3'
                    onClick={() => createCommentForTicket(ticket.ticket_uuid)}
                  ></i>
                </button>
              )}
            </div>
          </div>
          <div className='h-20px'>
            {formik.touched.ticket_comment_text && formik.errors.ticket_comment_text && (
              <div className='fv-help-block color-red'>{formik.errors.ticket_comment_text}</div>
            )}
          </div>
          {/* End::Reply input */}

          {ticket.comments.length > 0 && (
            <>
              {/* begin::Replies */}
              <div className='mb-7'>
                {ticket.comments.map((comment, index) => {
                  if (index < 10 * CountComment) {
                    return (
                      <div className='d-flex mb-5' key={index}>
                        {/* begin::Avatar */}
                        {/* <div className='symbol symbol-45px me-5'>
                  <img src={toAbsoluteUrl('/media/avatars/300.jpg')} alt='' />
                </div> */}
                        <div className='symbol symbol-50px me-5'>
                          <span
                            className='symbol-label'
                            style={{
                              backgroundColor: commentColors[comment?.comment_account_uuid]?.[0],
                            }}
                          >
                            <span
                              className='fs-2 fw-bold'
                              style={{color: commentColors[comment?.comment_account_uuid]?.[1]}}
                            >
                              {comment.comment_account_name.slice(0, 2).toUpperCase()}
                            </span>
                          </span>
                        </div>
                        {/* end::Avatar */}

                        {/* begin::Info */}
                        <div className='d-flex flex-column flex-row-fluid'>
                          {/* begin::Info */}
                          <div className='d-flex align-items-center flex-wrap mb-1'>
                            <span className='text-gray-800 text-hover-primary fw-bold me-2'>
                              {comment.comment_account_name}
                            </span>

                            <span className='text-gray-400 fw-semibold fs-7'>
                              {formatDate(new Date(comment.created_date_time))}
                            </span>
                            {comment.comment_account_uuid === currentUser?.account_uuid && (
                              // <>
                              //   {deleteCommentLoader ? (
                              //     <CircularProgress />
                              //   ) : (
                              <span
                                onClick={() => deleteTicketComment(comment.ticket_comment_uuid)}
                                className='cursor-pointer ms-auto text-gray-400 text-hover-primary fw-semibold fs-7'
                              >
                                <i className='bi bi-trash-fill fs-3' title='Delete comment'></i>
                              </span>
                              //   )}
                              // </>
                            )}
                          </div>
                          {/* end::Info */}

                          {/* begin::Post */}
                          <span className='text-gray-800 fs-7 fw-normal pt-1'>
                            {comment.ticket_comment_text}
                          </span>
                          {/* end::Post */}
                        </div>
                        {/* end::Info */}
                      </div>
                    )
                  }
                })}
              </div>
              {/* end::Replies */}
            </>
          )}

          {ticket.comments.length / (CountComment * 10) > 1 && (
            <p
              className='text-primary cursor-pointer'
              onClick={() => setCountComment((preval) => preval + 1)}
            >
              <u>Show previous comments</u>
            </p>
          )}
        </form>
        {/* End:Form */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default TicketingDetails

//  // <div
//                         //   className={`w-100 overflow-auto container position-relative ${styles.h_50vh}`}
//                         // >

//                           {/* <Document
//                             // file='\media\misc\sample.pdf'
//                             file={doc.document_path}
//                             onLoadSuccess={onDocumentLoadSuccess}
//                           >
//                             <Page
//                               pageNumber={pageNumber}
//                               loading={<div style={{height: '20px'}}>PDF is Loading</div>}
//                               noData='Annotations are disabled for this page'
//                               renderTextLayer={false}
//                             />
//                           </Document> */}
//                           {/* {numPages && numPages > 1 && (
//                             <div className='d-flex w-100 justify-content-center sticky-bottom'>
//                               <span className='mt-1'>
//                                 <button
//                                   className='btn p-1 text-primary bg-secondary rounded-left px-5'
//                                   disabled={pageNumber <= 1}
//                                   onClick={handlePrevious}
//                                 >
//                                   {`< Previous`}
//                                 </button>
//                                 <span className='btn p-1 bg-secondary rounded px-5 mx-5'>
//                                   Page {pageNumber} of {numPages}
//                                 </span>
//                                 <button
//                                   className='btn p-1 text-primary bg-secondary rounded-right px-5'
//                                   disabled={pageNumber === numPages}
//                                   onClick={handleNext}
//                                 >
//                                   {`Next >`}
//                                 </button>
//                               </span>
//                             </div>
//                           )} */}
//                         // </div>
